import { render, staticRenderFns } from "./OnBoardingChecklist.vue?vue&type=template&id=196e8e8a&"
import script from "./OnBoardingChecklist.vue?vue&type=script&lang=js&"
export * from "./OnBoardingChecklist.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingChecklist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports